export default [
  {
    path: "/app/coordination",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Coordenação",
      requiresAuth: true,
    },
    children: [
      /* Validate Frequency */
      {
        path: "validate-frequency",
        name: "coordination.validate-frequency",
        component: () => import("../validation/validate-frequency/views/List"),
        meta: {
          permission: "view_validate_frequency",
        },
      },
      {
        path: "validate-frequency/show/:id",
        name: "coordination.validate-frequency.show",
        component: () => import("../validation/validate-frequency/views/Show"),
        meta: {
          permission: "view_validate_frequency",
        },
      },
      /* Validate LessonPlanning */
      {
        path: "validate-lesson-planning",
        name: "coordination.validate-lesson-planning",
        component: () =>
          import("../validation/validate-lesson-planning/views/List"),
        meta: {
          permission: "view_validate_lesson_planning",
        },
      },
      {
        path: "validate-lesson-planning/show/:id",
        name: "coordination.validate-lesson-planning.show",
        component: () =>
          import("../validation/validate-lesson-planning/views/Show"),
        meta: {
          permission: "view_validate_lesson_planning",
        },
      },
      /* Validate LessonPlanning AEE */
      {
        path: "validate-lesson-planning-aee",
        name: "coordination.validate-lesson-planning-aee",
        component: () =>
          import("../validation/validate-lesson-planning-aee/views/List"),
        meta: {
          permission: "view_validate_lesson_planning_aee",
        },
      },
      {
        path: "validate-lesson-planning-aee/show/:id",
        name: "coordination.validate-lesson-planning-aee.show",
        component: () =>
          import("../validation/validate-lesson-planning-aee/views/Show"),
        meta: {
          permission: "view_validate_lesson_planning_aee",
        },
      },
      /* Validate Service-AEE */
      {
        path: "validate-service-aee",
        name: "coordination.validate-service-aee",
        component: () =>
          import("../validation/validate-service-aee/views/List"),
        meta: {
          permission: "view_validate_service_aee",
        },
      },
      {
        path: "validate-service-aee/show/:id",
        name: "coordination.validate-service-aee.show",
        component: () =>
          import("../validation/validate-service-aee/views/Show"),
        meta: {
          permission: "view_validate_service_aee",
        },
      },
      /* Absent Delay */
      {
        path: "absent-delay",
        name: "coordination.absent-delay",
        component: () => import("../absent-delay/views/List.vue"),
        meta: {
          permission: "view_absent_delay",
        },
      },
      {
        path: "absent-delay/create",
        name: "coordination.absent-delay.create",
        component: () => import("../absent-delay/views/Create.vue"),
        meta: {
          permission: "view_absent_delay",
        },
      },
      {
        path: "absent-delay/edit/:id",
        name: "coordination.absent-delay.edit",
        component: () => import("../absent-delay/views/Edit.vue"),
        meta: {
          permission: "view_absent_delay",
        },
      },
      /* Absent Delay Replacement */
      {
        path: "class-replacement",
        name: "coordination.class-replacement",
        component: () => import("../class-replacement/views/List.vue"),
        meta: {
          permission: "view_class_replacement_coordinator",
        },
      },
      /* Eventual Replacement */
      {
        path: "eventual-replacement",
        name: "coordination.eventual-replacement",
        component: () => import("../eventual-replacement/views/List.vue"),
        meta: {
          permission: "view_eventual_replacement",
        },
      },
      {
        path: "eventual-replacement/create",
        name: "coordination.eventual-replacement.create",
        component: () => import("../eventual-replacement/views/Create.vue"),
        meta: {
          permission: "view_eventual_replacement",
        },
      },
      {
        path: "eventual-replacement/show/:id",
        name: "coordination.eventual-replacement.show",
        component: () => import("../eventual-replacement/views/Show.vue"),
        meta: {
          permission: "view_eventual_replacement",
        },
      },
      {
        path: "eventual-replacement/edit/:id",
        name: "coordination.eventual-replacement.edit",
        component: () => import("../eventual-replacement/views/Edit.vue"),
        meta: {
          permission: "view_eventual_replacement",
        },
      },

      //----------------------------EVOLUTION REGISTER----------------------------
      {
        path: "evolution-register",
        name: "coordination.evolution-register",
        component: () => import("../evolution-register/views/List.vue"),
        meta: {
          permission: "view_evolution_registries",
        },
      },
      //----------------------------SCHEDULE SHIFT----------------------------
      {
        path: "lesson-reallocation",
        name: "coordination.lesson-reallocation",
        component: () =>
          import("../lesson-rescheduling/lesson-reallocation/views/List.vue"),
        meta: {
          permission: "view_class_replacement_coordinator",
        },
      },
    ],
  },
];
